<template>
  <svg
    width="12px"
    height="15px"
    viewBox="0 0 12 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>user</title>
    <desc>Created with Sketch.</desc>
    <g
      id="页面-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="CUSTOMER-CENTER"
        transform="translate(-805.000000, -501.000000)"
        fill="#CCCCCC"
      >
        <g id="编组-19" transform="translate(710.000000, 303.000000)">
          <path
            d="M97.2153846,202.251634 C97.2153846,200.179664 98.9098146,198.5 101,198.5 C103.090185,198.5 104.784615,200.179664 104.784615,202.251634 C104.784615,203.552639 104.116557,204.69897 103.101944,205.371925 C105.378924,206.216267 107,208.392694 107,210.944444 L107,212.5 L95,212.5 L95,210.944444 C95,208.392694 96.6210764,206.216267 98.8980556,205.371925 C97.883443,204.69897 97.2153846,203.552639 97.2153846,202.251634 Z M101,204.356209 C102.172543,204.356209 103.123077,203.413959 103.123077,202.251634 C103.123077,201.089309 102.172543,200.147059 101,200.147059 C99.827457,200.147059 98.8769231,201.089309 98.8769231,202.251634 C98.8769231,203.413959 99.827457,204.356209 101,204.356209 Z M101,206.643791 C98.6347793,206.643791 96.711624,208.520004 96.662501,210.852941 L105.337499,210.852941 C105.288376,208.520004 103.365221,206.643791 101,206.643791 Z"
            id="user"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UserSvg'
});
</script>
